import React, { useEffect, useState } from 'react';
import { BackButton, LoadingDocs, Notification, Spacer } from './Utils';
import strs from './strings';
import { auth } from './firebase';
import { getFirestoreCollection } from './firestore';
import { FormContext } from './context';
import curCase from './testCase';
// import curCase, {user} from './testCase'; 

const lang = strs.en;
// const test = user.cases;

function getNotifications() {

}

export default function CaseNotifications() {
	const [casesWithNotifications, setCasesWithNotifications] = useState(null);
	const [pendingNotifications, setPendingNotifications] = useState(null);
	const [curCase, setCurCase] = useState('mama llama samba');

	function setNotification() {

	}	

	function addToReceivedNotifications() {

	}

	useEffect(
		() => {
			const asyncWrapper = async () => {
					
				const uid = auth.currentUser.uid;
				const tmpCases = await getFirestoreCollection(`/users/${uid}/cases/`);
				const tmpCasesWithNotifications = tmpCases.filter( (tmpCase) => {
					return (tmpCase.curStatus === "submitted" && tmpCase?.pendingNotifications?.length); 
				});
				setCasesWithNotifications(tmpCasesWithNotifications);
				let tmpNotifications = {};
				tmpCasesWithNotifications.forEach(thisCase => {
					tmpNotifications[thisCase.id] = thisCase.pendingNotifications;
				})
				setPendingNotifications(tmpNotifications);
			}
		asyncWrapper();
		}, []
	);

	if (!pendingNotifications) {
		return <LoadingDocs />
	}
	else {
		return(
			<>
				<BackButton />
				<Spacer />
				<h2 className='primary-title'>{lang.notifications}</h2>
				<div>
					<Spacer />
					<h2 className='secondary-title centered-text'>{lang.activeNotifications}</h2>
					<Spacer />
					{
						Object.entries(pendingNotifications).map(([thisCase, notifications]) => {
							console.log(notifications);
							return(
							<div key={thisCase}>
								<FormContext.Provider value={{thisCase}} >
								<p>{thisCase}</p>
								<center>

							{
								notifications.map((notification) => {
									console.log(notification)
									return(
										<Notification setNotification={setNotification} addToReceivedNotifications={addToReceivedNotifications} notification={notification}/>
									);
								}) 
							}
								</center>
								</FormContext.Provider>
							</div>

							)
						})
					}
				</div>
			</>


		);
	}	
}
